import { useState } from "react";
import { Alert, Backdrop, Box, Button, CircularProgress, IconButton, LinearProgress, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import HtmlTooltip from "../../frames/html_tooltip";
import { useNavigate } from "react-router-dom";
import MenuFrame from "../../frames/menu_frame";
import CashNote from "./cash_note";
import { cashNotePayment, getAllCashNote } from "./note_halper";
import { getAccountsList } from "../accounts_halper";
import { DeleteTwoTone } from "@mui/icons-material";
import CreditScoreTwoToneIcon from '@mui/icons-material/CreditScoreTwoTone';

let allNoteList = [];

function NoteList() {
    const [isLoading, setIsLoading] = useState(false);
    const [noteList, setNoteList] = useState(null);
    const [activeTask, setActiveTask] = useState("");
    const [accList, setAccList] = useState(null);
    const [alertMessage, setAlertMessage] = useState(null);
    const navigator = useNavigate();

    const initData = async (auth) => {
        if (!auth) return;
        setNoteList(await getAllCashNote());
        setAccList(await getAccountsList())
    }

    const handleClose = () => {
        setActiveTask("");
    }

    const handleDialogOpen = (event) => {
        setActiveTask(event.target.value);
    }

    const makePayment = (note) => {
        if (isLoading) return;
        setIsLoading(true);
        cashNotePayment(note.note_num).then((res) => {
            setIsLoading(false);
            setAlertMessage({ severity: "success", message: "You have successfully posted the case note number " + note.note_num });
        }).catch((err) => {
            setAlertMessage({ severity: "error", message: err['message'] });
            setIsLoading(false);
        })
    }

    const handleSearch = (event) => {
        if (allNoteList.length === 0) return;
        const newList = allNoteList.filter((itm) =>
            itm.name.toLowerCase().startsWith(event.target.value.toLowerCase()) ||
            itm.ac_type.toLowerCase().startsWith(event.target.value.toLowerCase())
        );
        if (newList.length === 0) setNoteList(allNoteList)
        else setNoteList(newList);
    }

    return (
        <MenuFrame permission={"ACCOUNTS_FIN"} onInit={initData} screen="CASH_NOTES" onSearch={handleSearch}>
            <CashNote open={activeTask === "cash-note"} onClose={handleClose} accounts={accList} />
            {alertMessage === null ? "" :
                <Box sx={{ mt: 2, mb: 2 }}>
                    <Alert severity={alertMessage.severity}>{alertMessage.message}</Alert>
                </Box>
            }
            {noteList === null || noteList.length === 0 ? <LinearProgress color="primary" /> : ""}
            <Box sx={{ pt: 2, pb: 2 }}>
                <Button variant="outlined" color="secondary" onClick={() => { navigator("/accounts") }} style={{ margin: "0px 5px", textTransform: "none" }} >Back</Button>
                <Button variant="outlined" color="secondary" onClick={handleDialogOpen} style={{ margin: "0px 5px", textTransform: "none" }} value={"cash-note"} >Create New Cash Note</Button>
            </Box>
            <Backdrop sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })} open={isLoading} >
                <CircularProgress color="inherit" />
            </Backdrop>
            <TableContainer component={Paper}>
                <Table size="small" aria-label="user list" className="nowrap">
                    <TableHead>
                        <TableRow sx={{ '&:last-child td, &:last-child th': { fontWeight: "bold" } }}>
                            <TableCell></TableCell>
                            <TableCell>Note #</TableCell>
                            <TableCell>Date</TableCell>
                            <TableCell>Debit</TableCell>
                            <TableCell>Credit</TableCell>
                            <TableCell>Description</TableCell>
                            <TableCell align="right">Amount</TableCell>
                            <TableCell>Refrance</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {noteList === null || noteList.length === 0 ? <TableRow><TableCell colSpan={8}><Typography textAlign={"center"} color="textDisabled" variant="caption">Accounts loading...</Typography></TableCell></TableRow> :
                            noteList.map((row, idx) =>
                                <TableRow key={idx}>
                                    <TableCell>{
                                        row.transaction_num === null ?
                                            <>
                                                <HtmlTooltip title={<Typography variant="body2" color="info">Cancle this cash note</Typography>}>
                                                    <IconButton onClick={() => { }}><DeleteTwoTone fontSize="small" color="error" titleAccess={"Cancle"} /></IconButton>
                                                </HtmlTooltip>
                                                <HtmlTooltip title={<Typography variant="body2" color="info">Mark as Paid</Typography>}>
                                                    <IconButton onClick={() => { makePayment(row) }}><CreditScoreTwoToneIcon fontSize="small" color="success" titleAccess={"Paid"} /></IconButton>
                                                </HtmlTooltip>
                                            </>
                                            : ""}
                                    </TableCell>
                                    <TableCell>
                                        <Typography variant="body2">{row.note}</Typography>
                                    </TableCell>
                                    <TableCell>
                                        <Typography variant="body2">{row.created}</Typography>
                                    </TableCell>
                                    <TableCell>
                                        <Typography variant="body2">{row.debit_name}</Typography>
                                    </TableCell>
                                    <TableCell>
                                        <Typography variant="body2">{row.credit_name}</Typography>
                                    </TableCell>
                                    <TableCell>
                                        <Typography variant="body2">{row.description}</Typography>
                                    </TableCell>
                                    <TableCell>
                                        <Typography variant="body2" align="right">{row.amount}</Typography>
                                    </TableCell>
                                    <TableCell>
                                        <Typography variant="body2">{row.ref}</Typography>
                                    </TableCell>
                                </TableRow>
                            )
                        }
                    </TableBody>
                </Table>
            </TableContainer>
        </MenuFrame >
    );
}

export default NoteList;
